// 十进制颜色转换为十六进制颜色string
export function decimalToHexColor(decimal, defaultColor = "") {
  if (typeof decimal !== "number") return decimal;
  if (decimal === 0) return defaultColor;
  let hex = decimal.toString(16).toUpperCase();
  if (hex.length < 6) {
    let padding = 6 - hex.length;
    return `#${"0".repeat(padding) + hex}`;
  }
  return `#${hex}`;
}
// 十六进制颜色转换十进制
export function hexColorToDecimal(hexColor) {
  if (!/^#[0-9A-Fa-f]{6}$/.test(hexColor)) return;
  const hex = hexColor.replace("#", "");
  const decimal = parseInt(hex, 16);
  return decimal;
}
export function hexToRgba(hexColor, alpha = 1) {
  if (!hexColor) return "";
  // 去掉可能的 #
  hexColor = hexColor.replace("#", "");
  // 解析 R、G、B 分量
  const r = parseInt(hexColor.substring(0, 2), 16);
  const g = parseInt(hexColor.substring(2, 4), 16);
  const b = parseInt(hexColor.substring(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`; // 返回 RGBA 格式
}
export function rgbaToHex(color) {
  if (!color) return "";
  // 去除空格并转为小写
  color = color.trim().toLowerCase();

  // 判断输入颜色格式（RGBA 或 RGB）
  var isRgba = color.startsWith("rgba");
  var isRgb = color.startsWith("rgb");

  if (isRgba || isRgb) {
    // 提取颜色分量的值
    var colorValues = color
      .substring(color.indexOf("(") + 1, color.lastIndexOf(")"))
      .split(",");
    var red = parseInt(colorValues[0].trim());
    var green = parseInt(colorValues[1].trim());
    var blue = parseInt(colorValues[2].trim());
    var alpha = isRgba ? parseFloat(colorValues[3].trim()) : 1; // 默认为不透明

    // 将颜色分量转换为对应的 HEX 值
    var hex =
      "#" +
      ((1 << 24) | (red << 16) | (green << 8) | blue)
        .toString(16)
        .slice(1)
        .toUpperCase();

    return hex;
  } else {
    return color; // 不是 RGBA 或 RGB 格式的颜色，直接返回原始值
  }
}

export function hexToHSV(hexColor, params = {}) {
  if (!hexColor) return "";
  const { sMin, sMax, vMin, vMax } = params;
  // 去掉可能的 #
  hexColor = hexColor.replace("#", "");

  // 解析 R、G、B 分量
  const r = parseInt(hexColor.substring(0, 2), 16) / 255;
  const g = parseInt(hexColor.substring(2, 4), 16) / 255;
  const b = parseInt(hexColor.substring(4, 6), 16) / 255;

  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  const delta = max - min;

  let h = 0;
  let s = 0;
  let v = max * 100;

  if (delta !== 0) {
    s = (delta / max) * 100;
    switch (max) {
      case r:
        h = (g - b) / delta + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / delta + 2;
        break;
      case b:
        h = (r - g) / delta + 4;
        break;
    }
    h *= 60;
  }

  if (sMin !== undefined) {
    s = Math.max(sMin, s);
  }
  if (sMax !== undefined) {
    s = Math.min(sMax, s);
  }
  if (vMin !== undefined) {
    v = Math.max(vMin, v);
  }
  if (vMax !== undefined) {
    v = Math.min(vMax, v);
  }

  return {
    h: Math.round(h),
    s: Math.round(s),
    v: Math.round(v),
  };
}
export function hsvToHex({ h, s, v }) {
  let r, g, b;
  const c = ((v / 100) * s) / 100;
  const x = c * (1 - Math.abs(((h / 60) % 2) - 1));
  const m = v / 100 - c;

  let rgb;
  if (h >= 0 && h < 60) {
    rgb = [c, x, 0];
  } else if (h >= 60 && h < 120) {
    rgb = [x, c, 0];
  } else if (h >= 120 && h < 180) {
    rgb = [0, c, x];
  } else if (h >= 180 && h < 240) {
    rgb = [0, x, c];
  } else if (h >= 240 && h < 300) {
    rgb = [x, 0, c];
  } else {
    rgb = [c, 0, x];
  }

  r = Math.abs(Math.round((rgb[0] + m) * 255));
  g = Math.abs(Math.round((rgb[1] + m) * 255));
  b = Math.abs(Math.round((rgb[2] + m) * 255));

  const toHex = (x) => {
    const hex = x.toString(16);
    return hex.length === 1 ? "0" + hex : hex;
  };

  const hexColor = `#${toHex(r)}${toHex(g)}${toHex(b)}`;
  return hexColor.toUpperCase();
}

export function getColorsTheme(colors) {
  let minV = 100
  if (colors.length === 0) return 'dark'
  colors.forEach(item => {
    const hsv = hexToHSV(item)
    if (hsv.v < minV) {
      minV = hsv.v
    }
  })
  if (minV <= 60) {
    return 'dark'
  } else {
    return 'light'
  }
}